export const shipmentLookupFieldDropdown =  [
	{
	  title: "Search by Tracking / PRO Number",
	  value: "shpTrackingNumber"
	},
	{
	  title: "Search by Order ID Number",
	  value: "shpEntityId"
	},
	{
	  title: "Search by Sales Order Number",
	  value: "salesOrderNbr"
	},
	{
	  title: "Search by Purchase Order Number",
	  value: "purchaseOrderNbr"
	},
	{
	  title: "Search by Shipment Number",
	  value: "shpShipmentNumber"
	},
	{
	  title: "Search by BOL",
	  value: "shpBol"
	},
]



// WEBPACK FOOTER //
// ./src/pages/proofOfDelivery/podShipmentSummary/filter/shipmentLookupFields.js